// ConstructionPlanArea を子(場所区分 locations / 計画材料 planned_materials)込みで put/patch するための
// Web 側ペイロードスキーマ。API 側 src/schema/console/construction_plan_area.ts と同方針。
// 子は area の専用トランザクション route(/put-construction-plan-area, /patch-construction-plan-area)で
// 親と一括登録される(サーバが子の id を採番)。
import { z } from "zod";
import { ConstructionPlanAreaBaseSchema } from "../generated/ConstructionPlanArea";
import { ConstructionPlanAreaLocationBaseSchema } from "../generated/ConstructionPlanAreaLocation";
import { ConstructionPlanAreaPlannedMaterialBaseSchema } from "../generated/ConstructionPlanAreaPlannedMaterial";

const locationNested = ConstructionPlanAreaLocationBaseSchema.put.omit({ construction_plan_area_id: true });
const plannedMaterialNested = ConstructionPlanAreaPlannedMaterialBaseSchema.put.omit({ construction_plan_area_id: true });

export const putConstructionPlanAreaWithChildrenSchema = ConstructionPlanAreaBaseSchema.put.extend({
  locations: z.array(locationNested).default([]),
  planned_materials: z.array(plannedMaterialNested).default([]),
});

export const patchConstructionPlanAreaWithChildrenSchema = ConstructionPlanAreaBaseSchema.patch.extend({
  locations: z.array(locationNested).optional(),
  planned_materials: z.array(plannedMaterialNested).optional(),
});

export type PutConstructionPlanAreaWithChildrenPayload = z.infer<typeof putConstructionPlanAreaWithChildrenSchema>;
export type PatchConstructionPlanAreaWithChildrenPayload = z.infer<typeof patchConstructionPlanAreaWithChildrenSchema>;

// 施工箇所の正規化応答(重複排除)。子2種は related バケットで返し、ネスト形は返さない
// (web は従来から zod strip で子を捨てており、クライアント可視の契約は平坦な施工箇所行のみ)。
export const normalizedConstructionPlanAreaResponseSchema = z.object({
  ConstructionPlanAreas: ConstructionPlanAreaBaseSchema.rows,
  related: z.object({
    ConstructionPlanAreaLocations: z.array(ConstructionPlanAreaLocationBaseSchema.base),
    ConstructionPlanAreaPlannedMaterials: z.array(ConstructionPlanAreaPlannedMaterialBaseSchema.base),
  }),
});
export type NormalizedConstructionPlanAreaResponse = z.infer<typeof normalizedConstructionPlanAreaResponseSchema>;
